import React, { useMemo } from 'react';
import Table from 'components/Table/Table';
import { HeroIconTrendingDown, HeroIconTrendingUp } from 'toolbox';
import { curr } from 'helpers/curr';

const DemoTable = () => {
  const columns = useMemo(
    () => [
      { Header: 'Currency Book', accessor: 'currencyBook' },
      {
        Header: 'Balance',
        accessor: ({ balance, currency }: any) => (
          <div>
            <h4>
              {balance < 0 ? '-' : ''}
              {curr(balance, currency)}
            </h4>
          </div>
        ),
      },
      {
        Header: 'Weekly Change',
        accessor: ({ weeklyChange, currency }: any) => (
          <div>
            {weeklyChange <= 0 ? (
              <HeroIconTrendingDown className="inline h-4 -ml-2 text-red-700" />
            ) : (
              <HeroIconTrendingUp className="inline h-4 -ml-2 text-green-600" />
            )}
            {curr(weeklyChange, currency)}
          </div>
        ),
      },
      {
        Header: 'Interest',
        accessor: ({ weeklyYield }: any) =>
          `${weeklyYield < 0 ? '-' : ''}${weeklyYield}%`,
      },
    ],
    [],
  );

  const data = [
    {
      currencyBook: 'Pool 1 GBP',
      currency: 'GBP',
      balance: 25000000,
      weeklyChange: 1000000,
      weeklyYield: 0.75,
    },
    {
      currencyBook: 'Pool 1 USD',
      currency: 'USD',
      balance: 214000000,
      weeklyChange: 0,
      weeklyYield: 1.12,
    },
    {
      currencyBook: 'Pool 1 EUR',
      currency: 'EUR',
      balance: 20000000,
      weeklyChange: 3120000,
      weeklyYield: 0,
    },
  ];

  return <Table columns={columns as any} data={data} />;
};

export default DemoTable;
